import script from "./AddressBlockEthereumSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBlockEthereumSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./AddressBlockEthereumSkeleton.vue?vue&type=style&index=0&id=b0bf9e60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0bf9e60"]])

export default __exports__